import { resourceObject } from './resourceObject'

export const assetReferences = {
  createResource: resourceObject,
}
